module.exports = __webpack_public_path__ + "static/media/pan-antano-320g-b.87fd49a2.webp";